export default "__VITE_ASSET__7IOhm8gy__"